import React from 'react';

import Card from './Card';
import CardGroup from './CardGroup';
import CompareBlock from './CompareBlock';
import CompareOr from './svgs/CompareOr';

export default ({
  className = 'mb12',
}) => (
  <CardGroup className={className}>
    <Card>
      <h3>How to return your old equipment</h3>
    </Card>
    <Card className="card--secondary">
      <CompareBlock svg={CompareOr}>
        <div className="text-center">
          <img className="mb12" width="143" height="107" src="https://static.cimcontent.net/common-web-assets/svg/shipping_label.svg" alt="shipping label" />
          <h5>Pre-Paid Shipping Label</h5>
        </div>
        <div className="text-center">
          <img className="mb12" width="180" height="107" src="https://static.cimcontent.net/common-web-assets/svg/order-hub/store.svg" alt="store" />
          <h5>Xfinity Store </h5>
        </div>
      </CompareBlock>
    </Card>
    <Card className="card--secondary">
      <p>
        {`Once you receive and activate your new devices you’ll need to return your old equipment
        within 30 days to avoid being charged. Returning is free and easy. You can return your device
         to an Xfinity Retail store, a UPS store, or by printing a pre-paid UPS label. `}
        <a
          href="https://www.xfinity.com/support/articles/returning-your-equipment"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn More
        </a>
      </p>
    </Card>
  </CardGroup>
);
